import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EmployeesApiService } from 'src/app/core/employees-api/employees-api.service';
import Employee from 'src/app/service/model/Employee';

@Component({
  selector: 'mandates-add-employee-access-dialog',
  templateUrl: './add-employee-access-dialog.component.html',
  styleUrls: ['./add-employee-access-dialog.component.scss'],
})
export class AddEmployeeAccessDialog implements OnInit, OnDestroy {
  employees: Employee[];
  employee: Employee;

  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<AddEmployeeAccessDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public employeeApiService: EmployeesApiService
  ) {}

  ngOnInit(): void {
    this.employeeApiService.employees$
      .pipe(takeUntil(this.destroy$))
      .subscribe((employees) => {
        this.employees = employees;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onCancelClick(): void {
    this.dialogRef.close({ confirm: false, employee: null });
  }

  onConfirmClick(): void {
    this.dialogRef.close({ confirm: true, employee: this.employee });
  }
}

interface DialogData {
  title: string;
  cancelText: string;
  confirmText: string;
  confirmColor: string;
}
